import { render, staticRenderFns } from "./termService.vue?vue&type=template&id=ff133136&scoped=true&"
import script from "./termService.vue?vue&type=script&lang=js&"
export * from "./termService.vue?vue&type=script&lang=js&"
import style0 from "./termService.vue?vue&type=style&index=0&id=ff133136&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff133136",
  null
  
)

export default component.exports